module.exports = __webpack_public_path__ + "static/media/2.e252c4d4.jpg";